export enum UserStatus {
  INACTIVE = { code: 0, description: 'GENERAL.INACTIVE' } as any,
  ACTIVE = { code: 1, description: 'GENERAL.ACTIVE' } as any,
  DRAFT = { code: 2, description: 'GENERAL.DRAFT' } as any,
  REMOVED = { code: 3, description: 'GENERAL.REMOVED' } as any,
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/user-status.enum.ts